import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {HttpClient} from "@angular/common/http";
import {map} from "rxjs/operators";

@Injectable()
export class DeploymentWorkflowService {
  private url: string = "/api/DeploymentWorkflow";

  constructor(private http: HttpClient) {}

  sendDevicesToK2(id, assetIds): Promise<string> {
    return this.http.post(`${this.url}/send-devices-to-k2?deploymentId=${id}`, {assetIds})
      .pipe(map(json => json["message"]))
      .toPromise();
  }

  sendDevicesToITSM(id, assetIds): Promise<string> {
    return this.http.post(`${this.url}/send-devices-to-itsm?deploymentId=${id}`, {assetIds})
      .pipe(map(json => json["message"]))
      .toPromise();
  }

  getAssetList(deploymentId: string): Observable<any> {
    return this.http.get(`${this.url}/get-asset-list?deploymentId=${deploymentId}`);
  }

  enableExportPageCounts(workflowId: string): Observable<any> {
    return this.http.get(`${this.url}/enable-export-pagecounts?workflowId=${workflowId}`);
  }

  getInitialPagecountsStatus(deploymentId: string): Observable<any> {
    return this.http.get(`${this.url}/export-pagecounts-status?deploymentId=${deploymentId}`);
  }

  getAssetForSapUploadList(deploymentId: string): Observable<any> {
    return this.http.get(`${this.url}/get-sent-to-sap-asset-list?deploymentId=${deploymentId}`);
  }

  updateSentToSAP(deploymentId: string, state: boolean, assetId?: string): Observable<any> {
    return this.http.post(`${this.url}/update-sent-to-sap`, {deploymentId, state, assetId});
  }

  messageToTransitionLeads(
    message: string,
    projectId: string,
    deploymentId: string,
    workflowId: string,
  ): Observable<any> {
    return this.http.post(`${this.url}/message-to-transition-leads`, {projectId, message, deploymentId, workflowId})
      .pipe(map(result => ({success: !!result["success"]})));
  }

  sendSmsData(
    deploymentId: string,
    projectId: string,
  ): Promise<{success: boolean, message: string}> {
    return this.http.get<{success: boolean, message: string}>(
      `${this.url}/export-sms-config`, {params: {deploymentId, projectId}},
    )
      .pipe(map(json => ({success: json["success"], message: json["message"]})))
      .toPromise();
  }

  isSendToSmsReady(
    deploymentId: string,
    projectId: string,
  ): Promise<{areThereSmsRulesToSend: boolean}> {
    return this.http.get<{areThereSmsRulesToSend: boolean}>(
      `${this.url}/sms-ready-status`, {params: {deploymentId, projectId}},
    )
      .pipe(map(json => ({areThereSmsRulesToSend: json["areThereSmsRulesToSend"]})))
      .toPromise();
  }
}
